import React from "react";
import "./Card.css"; // Import custom styles

const Card = ({ title, value, icon, color }) => {
  return (
    <div className="dashboard-card" style={{ backgroundColor: color }}>
      <div className="icon-container">{icon}</div>
      <h5 className="card-title">{title}</h5>
      <h2 className="card-value">{value}</h2>
    </div>
  );
};

export default Card;
